import { DateUtils } from '@vectord/utils';

function generateTimeString(timeInMs) {
  let hours = Math.floor(timeInMs / DateUtils.ONE_HOUR);
  const meridian = hours >= 12 ? 'PM' : 'AM';
  hours = String(hours % 12 || 12);
  const minutes = String(
    Math.floor((timeInMs % DateUtils.ONE_HOUR) / DateUtils.ONE_MINUTE)
  );

  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')} ${meridian}`;
}

export default generateTimeString;
